
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["receiveMessageFromMaster"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "4bf901cfa1215ffb4fc4.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			